import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Card } from "@/components/ui/card";
import { Warning, X } from "@phosphor-icons/react";

export default function Fraud() {
    const { t } = useI18n();
    const [items, setItems] = useState([]);
    const [params, setParams] = useSearchParams();
    const gov = params.get("gov");
    useEffect(() => {
        const url = gov ? `/reports/fraud-by-gov?gov=${gov}` : "/reports/fraud";
        api.get(url).then((r) => setItems(r.data.items));
    }, [gov]);
    return (
        <div className="space-y-6" data-testid="fraud-page">
            <div>
                <div className="text-[11px] tracking-[0.35em] uppercase text-primary">· ANOMALY WATCH</div>
                <h1 className="text-3xl font-bold tracking-tight mt-1">{t("fraud")}</h1>
            </div>
            {gov && (
                <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/10 border border-primary/30 text-primary rounded-sm text-xs uppercase tracking-widest" data-testid="fraud-gov-badge">
                    Governorate: {gov}
                    <button onClick={() => setParams({})} className="ms-1"><X size={12} weight="bold" /></button>
                </div>
            )}
            <Card className="rounded-sm border-border overflow-hidden">
                <table className="w-full data-grid text-sm">
                    <thead className="bg-secondary text-xs uppercase tracking-widest">
                        <tr>
                            <th className="text-start">{t("reference")}</th>
                            <th className="text-start">{t("ownerName")}</th>
                            <th className="text-start">{t("vin")}</th>
                            <th className="text-start">{t("fraudFlagsCol")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.length === 0 && <tr><td colSpan={4} className="text-center py-10 text-muted-foreground">{t("noData")}</td></tr>}
                        {items.map((a) => (
                            <tr key={a.id} className="border-t border-border" data-testid={`fraud-row-${a.id}`}>
                                <td className="mono"><Link to={`/app/applications/${a.id}`} className="underline">{a.reference}</Link></td>
                                <td>{a.owner?.full_name}</td>
                                <td className="mono">{a.vehicle?.vin}</td>
                                <td>
                                    <div className="flex flex-wrap gap-1">
                                        {a.fraud_flags?.map((f) => (
                                            <span key={f} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm bg-primary/10 border border-primary/30 text-primary text-[10px] uppercase tracking-widest">
                                                <Warning size={11} weight="fill" />{f}
                                            </span>
                                        ))}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card>
        </div>
    );
}
